import i18n from "intl/i18n"

export enum ArticleClass {
    generic = "generic",
    wheel = "wheel",
    snowChain = "snowChain",
    bucket = "bucket",
    backhoeBucket = "backhoeBucket",
    twoInOneBucket = "twoInOneBucket",
    rigidDitchCleaningBucket = "rigidDitchCleaningBucket",
    swivelBucket = "swivelBucket",
    universalBucket = "universalBucket",
    grapple = "grapple",
    adapterPlate = "adapterPlate",
    addOnCompactor = "addOnCompactor",
    hydraulicHammer = "hydraulicHammer",
    quickCoupler = "quickCoupler",
    lightMaterialBucket = "lightMaterialBucket",
    forkCarrier = "forkCarrier",
}

export enum ArticleClassField {
    dimensions = "dimensions", // includes measurementSystemId, length, width, height
    volume = "volume",
    weight = "weight",
    wheel = "wheel", // includes wheelWidth, wheelHeight, inch, loadSpeedIndex, constructionCode, isTubeless, starMarking
    quickCouplingSystem = "quickCouplingSystem",
    connectionType = "connectionType",
    teeth = "teeth",
    cuttingEdge = "cuttingEdge",
    heavyDuty = "heavyDuty",
    locking = "locking",
    controlSystem = "controlSystem",
    agility = "agility",
}

export interface IArticleClassInfoDto {
    class: ArticleClass
    visibleFields: ArticleClassField[]
}

export default class ArticleClassInfo {
    class: ArticleClass
    visibleFields: ArticleClassField[]

    constructor(dto: IArticleClassInfoDto) {
        this.class = dto.class
        this.visibleFields = dto.visibleFields
    }
}

export function getArticleClassName(articleClass: ArticleClass): string {
    switch (articleClass) {
        case ArticleClass.generic:
            return i18n.t("articleClass.generic")
        case ArticleClass.wheel:
            return i18n.t("articleClass.wheel")
        case ArticleClass.snowChain:
            return i18n.t("articleClass.snowChain")
        case ArticleClass.bucket:
            return i18n.t("articleClass.bucket")
        case ArticleClass.backhoeBucket:
            return i18n.t("articleClass.backhoeBucket")
        case ArticleClass.twoInOneBucket:
            return i18n.t("articleClass.twoInOneBucket")
        case ArticleClass.rigidDitchCleaningBucket:
            return i18n.t("articleClass.ditchCleaningBucket")
        case ArticleClass.swivelBucket:
            return i18n.t("articleClass.swivelBucket")
        case ArticleClass.universalBucket:
            return i18n.t("articleClass.universalBucket")
        case ArticleClass.grapple:
            return i18n.t("articleClass.grapple")
        case ArticleClass.adapterPlate:
            return i18n.t("articleClass.adapterPlate")
        case ArticleClass.addOnCompactor:
            return i18n.t("articleClass.addOnCompactor")
        case ArticleClass.hydraulicHammer:
            return i18n.t("articleClass.hydraulicHammer")
        case ArticleClass.quickCoupler:
            return i18n.t("articleClass.quickCoupler")
        case ArticleClass.lightMaterialBucket:
            return i18n.t("articleClass.lightMaterialBucket")
        case ArticleClass.forkCarrier:
            return i18n.t("articleClass.forkCarrier")
        default:
            return ""
    }
}
